(() => {
  const config = window.foriaCartRules || {};
  const minimum = Number(config.minimum) || 24;
  const multiple = Number(config.multiple) || 24;
  const variantUnits = config.variantUnits || {};

  const unitsForItem = (item) => {
    const variantId = String(item.variant_id || item.id || '');
    const configuredUnits = Number(variantUnits[variantId]);
    if (configuredUnits > 0) return configuredUnits;

    const title = String(item.variant_title || item.title || '');
    const packMatch = title.match(/pack\s*(\d+)/i);
    return packMatch ? Number(packMatch[1]) : 1;
  };

  const totalUnits = (cart) => (cart.items || []).reduce(
    (total, item) => total + (Number(item.quantity) || 0) * unitsForItem(item),
    0,
  );

  const statusFor = (units) => {
    const remainder = units % multiple;
    const valid = units >= minimum && remainder === 0;
    const needed = units < minimum ? minimum - units : remainder === 0 ? 0 : multiple - remainder;
    return { units, valid, needed };
  };

  const updateUI = (status) => {
    document.querySelectorAll('[data-foria-cart-rule]').forEach((notice) => {
      notice.dataset.cartUnits = String(status.units);
      notice.dataset.valid = String(status.valid);
      const output = notice.querySelector('[data-foria-cart-rule-status]');
      if (output) {
        output.textContent = status.valid
          ? `${status.units} botellas. El pedido está listo.`
          : `Ahora tienes ${status.units} botellas. Añade ${status.needed} más para continuar.`;
      }
    });

    document.querySelectorAll('[data-foria-checkout]').forEach((button) => {
      button.disabled = !status.valid;
      button.setAttribute('aria-disabled', String(!status.valid));
    });

    document.querySelectorAll('.additional-checkout-buttons').forEach((container) => {
      container.hidden = !status.valid;
    });
  };

  const fetchStatus = async () => {
    const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('No se pudo comprobar el carrito.');
    const cart = await response.json();
    const status = statusFor(totalUnits(cart));
    updateUI(status);
    return status;
  };

  const blockInvalidCheckout = async (event) => {
    event.preventDefault();
    try {
      const status = await fetchStatus();
      if (status.valid) {
        const form = event.target.closest('form');
        if (form) HTMLFormElement.prototype.submit.call(form);
        else window.location.assign('/checkout');
        return;
      }

      document.querySelector('[data-foria-cart-rule]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (_error) {
      const errorTarget = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errorTarget) errorTarget.textContent = 'No hemos podido validar el pedido. Recarga la página e inténtalo de nuevo.';
    }
  };

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest('[data-foria-checkout]');
    if (!checkout || checkout.disabled) return;
    blockInvalidCheckout(event);
  }, true);

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!submitter?.matches('[data-foria-checkout]')) return;
    blockInvalidCheckout(event);
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    fetchStatus().catch(() => {});
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.cartData?.items) updateUI(statusFor(totalUnits(event.cartData)));
        else fetchStatus().catch(() => {});
      });
    }
  });
})();
